<template>
  <div class="career-track">
    <TrackHeroSection :track="track" in-track offset />
    <div class="content container">
      <div class="row">
        <div class="col col-10 offset-1">
          <Breadcrumb :breadcrumb="trackBreadcrumb" class="track-breadcrumb" />
          <ListCourses :track="track" />
        </div>
      </div>
    </div>
    <div class="header-sm">
      <span v-if="$config.platform === 'ds'" class="img" :style="{ backgroundImage: `url(${require(`@itbpbg/lms-components/src/assets/images/career-track-${track.id}.png`)})` }" />
      <span v-else class="img" :style="{ backgroundImage: `url(${require(`@itbpbg/lms-components/src/assets/images/fa/fa-career-track-${track.id}.jpg`)})` }" />
      <div>
        <p class="h5">
          {{ track.name }} Career Track
        </p>
        <p>{{ track.totalCourses }} Courses</p>
      </div>
      <nuxt-link to="/signup/" class="btn-primary btn-lg">
        Start Now
      </nuxt-link>
    </div>
  </div>
</template>

<script>
import global from '@itbpbg/lms-components/src/mixins/global';
import TrackHeroSection from '@itbpbg/lms-components/src/Career-tracks/HeroSection';
import ListCourses from '@itbpbg/lms-components/src/Career-tracks/ListCourses';
import Breadcrumb from '@itbpbg/lms-components/src/components/Breadcrumb';

export default {
  components: {
    TrackHeroSection, ListCourses, Breadcrumb,
  },
  mixins: [global],
  async asyncData({
    $axios, route, error,
  }) {
    const [track, page] = await Promise.all([
      $axios.$get(`/career-tracks/${route.params.track}`).catch(() => false),
      $axios.$get(`/pages/track-${route.params.track}`).catch(() => false),
    ]);

    if (!track.id) {
      return error({ statusCode: 404, message: 'Page not found' });
    }

    return {
      track,
      page,
    };
  },
  head() {
    const coursesList = [];
    this.track.courses.filter(((c) => c.type !== 'Elective')).forEach((item, i) => {
      coursesList.push({
        '@type': 'ListItem',
        position: i + 1,
        url: `${this.$config.siteUrl}/courses/${item.slug}/`,
      });
    });

    const linkedData = this.$linkedDataLoad([
      { key: 'WebSite' },
      { key: 'WebPage', values: this.page },
      {
        key: 'CoursesList',
        values: {
          '@context': 'https://schema.org',
          '@type': 'ItemList',
          itemListElement: coursesList || [],
        },
      },
    ]);

    return {
      titleTemplate: `${this.page.metaTitle}%s`,
      link: [
        { rel: 'canonical', href: this.canonicalURL() },
      ],
      meta: this.metaProps(this.page),
      script: [linkedData],
    };
  },
  computed: {
    trackBreadcrumb() {
      return [
        {
          slug: '/career-tracks/',
          name: 'Career Tracks',
        },
        {
          slug: '',
          name: this.track.name,
        },
      ];
    },
  },
  created() {
    this.handleScroll();
  },
  methods: {
    handleScroll() {
      if (process.client) {
        window.onscroll = () => {
          const smallHeader = this.$el.querySelector('.header-sm');
          if (this.$el.querySelector('.content').getBoundingClientRect().top - 100 > 0) {
            smallHeader.classList.remove('fixed');
          } else {
            smallHeader.classList.add('fixed');
          }
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.career-track {
  overflow: hidden;
  background: var(--main-light-shade-1);

  ::v-deep .list {
    .holder{
      padding-bottom: 16px;
      margin-bottom: 0;
    }
  }

  ::v-deep .footer {
      padding-left: 64px;
    }
}

.content {
  margin-top: var(--spacing-48);
  padding-bottom: var(--spacing-120);

  .track-breadcrumb {
    padding-bottom: var(--spacing-24);
    border-bottom: 1px solid var(--main-light-shade-3);
  }
}

.header-sm {
  position: fixed;
  left: 0;
  right: 0;
  z-index: 1;
  bottom: -96px;
  transition: ease all var(--duration);
  color: var(--main-light);
  background: var(--main-dark-shade-1);
  height: 96px;
  display: flex;
  align-items: center;
  padding: var(--spacing-14) var(--spacing-40);

  .img {
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    image-rendering: -webkit-optimize-contrast;
    width: 110px;
    height: 100%;
    border-radius: 4px;
    margin-right: 20px;

    .tech-img {
      text-align: right;
      margin: 4px 4px 0 0;
      display: flex;
      justify-content: flex-end;

      svg {
        max-width: 11px;
      }
    }
  }

  .h5,
  p {
    margin: 0;
  }

  p {
    margin-top: var(--spacing-6);
  }

  .btn-primary {
    margin-left: auto;
  }

  &.fixed {
    bottom: 0;
    transition: ease all var(--duration);

    .btn-primary {
      padding-left: 70px;
      padding-right: 70px;
    }
  }
}

.fa {
  .career-track {
    background: var(--main-light-shade-2);
  }

  .header-sm {
    padding: 0 var(--spacing-40) 0 0;
    background: var(--main-dark);

    .img {
      width: 172px;
      margin-right: 0;
    }

    p:last-of-type {
      color: var(--main-light-shade-4);
    }
  }
}

@include bp($bp-laptop) {
  .career-track {
    .hero-section {
      ::v-deep .h3 {
        font-size: 28px;
      }
    }
  }
}

@include bp($bp-mobile) {
  .content {
    margin-top: 0;
    padding-top: var(--spacing-20);

    .track-breadcrumb {
      display: none;
    }
  }

  .header-sm {
    display: none;
  }

  .fa {
    .content {
      .track-breadcrumb {
        display: block;
      }
    }
  }
}

@include bp($bp-phone) {
  .content {
    ::v-deep div .list {
      .holder {
        padding-bottom: var(--spacing-48);
      }

      .h3 {
        width: 100%;
      }
    }

    ::v-deep .footer {
      padding-left: var(--spacing-48);
    }
  }
}
</style>
